import spinner from '../../../components/spinner';

let instance = null;

class PrequalifySpinner {
	constructor() {
		if (!instance) {
			this._spinner = spinner;
			instance = this;
		}

		return instance;
	}

	show() {
		this._spinner.show();
	}

	hide() {
		this._spinner.hide();
	}
}

export default new PrequalifySpinner();
